import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router-dom'
import { SpinnerLoader } from 'shared/ui'
import { APP_API_FALLBACK_ENABLED } from 'shared/config/lib/getConfigUrls'
import { clearSessionIntercom, initIntercom } from 'entities/Intercom'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useEventChangeApi } from 'entities/WebSocket/events/EventChangeApi'
import { CommonLayout } from './CommonLayout'

type IAuthRefreshLayoutProps = {
  isTryRefreshWithoutToken?: boolean
  withoutCommonComponents?: boolean
}

export const AuthRefreshLayout = observer(
  ({ isTryRefreshWithoutToken, withoutCommonComponents }: IAuthRefreshLayoutProps) => {
    const entities = useEntitiesContext()
    const { authStore } = entities
    const { refresh, error } = authStore
    const [loading, setLoading] = useState(true)

    useEventChangeApi()

    useEffect(() => {
      refresh({
        isTryRefreshWithoutToken,
        enabledChangeDomainApi: Boolean(APP_API_FALLBACK_ENABLED),
      })
        .then((data) => {
          if (!data?.is_login) {
            clearSessionIntercom()
            initIntercom({
              entities: entities,
            })
            authStore.removeToken()
            setLoading(false)
          }
        })
        .then(() => {
          setLoading(false)
        })
    }, [])

    if (loading) {
      return (
        <div className={'spinner'}>
          <SpinnerLoader ariaLabel={'AuthRefreshLayout'} />
        </div>
      )
    }

    if (error) {
      return <>{error}</>
    }

    return (
      <>
        {!withoutCommonComponents && <CommonLayout />}
        <Outlet />
      </>
    )
  }
)
